export default function convertUTCDateToLocalDate(date: Date) {
  return date;
}
